module.exports = __webpack_public_path__ + "media/FIVEx_tutorial_3.11e32f94.mp4";